import * as React from "react"
const SvgRecommendationIncoming = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16.053 5.096q-2.901-1.674-6.099-.836Q6.757 5.098 5.082 8l-.088.151-.33-1.23a.95.95 0 0 0-.468-.588.95.95 0 0 0-.744-.111.95.95 0 0 0-.588.468.95.95 0 0 0-.112.744l.952 3.552a.96.96 0 0 0 .456.61.96.96 0 0 0 .756.09l3.552-.952a.95.95 0 0 0 .588-.469.95.95 0 0 0 .112-.743.95.95 0 0 0-.469-.589.95.95 0 0 0-.743-.111l-1.23.329.088-.152q1.25-2.164 3.651-2.799t4.588.628q.346.201.657.437.31.237.573.533.306.321.705.378.4.058.76-.167a.9.9 0 0 0 .427-.663.87.87 0 0 0-.253-.738 6.4 6.4 0 0 0-.873-.836 8 8 0 0 0-.996-.676" />
    <path
      d="M8.298 16.734q.31.236.656.437 2.185 1.261 4.585.628 2.4-.634 3.648-2.8l.087-.151-1.228.33a.95.95 0 0 1-.743-.113.95.95 0 0 1-.469-.588.95.95 0 0 1 .112-.743.95.95 0 0 1 .588-.47l3.549-.95a.96.96 0 0 1 .755.09.96.96 0 0 1 .456.61l.951 3.55a.95.95 0 0 1-.112.745.95.95 0 0 1-.587.468.95.95 0 0 1-.744-.112.95.95 0 0 1-.468-.588l-.329-1.23-.087.152q-1.674 2.901-4.87 3.74-3.194.839-6.093-.836a7.4 7.4 0 0 1-1.01-.7 8 8 0 0 1-.889-.86.86.86 0 0 1-.23-.724.85.85 0 0 1 .413-.642q.36-.225.77-.16.411.063.716.384.263.296.573.532"
      opacity={0.25}
    />
  </svg>
)
export default SvgRecommendationIncoming
